const shopifyUtils = {
    createBlogArticlesHeaders() {
        return {
            'xtkn': ""
        }
    },
}

export default shopifyUtils;